import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import Unsubscribe from "@/pages/Unsubscribe";

export const Route = createFileRoute("/unsubscribe")({
  head: () => seoHead({
    title: "Cancelar e-mails | Shopping do Bem",
    description: "Gerencie o envio de e-mails do Shopping do Bem.",
    path: "/unsubscribe",
    noindex: true,
  }),
  component: Unsubscribe,
});
